import styled from "styled-components";

export const Link = styled.a`
	color: var(--primary);
	text-decoration: none;

	font-family: Inter;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px;

	cursor: pointer;

	&:hover {
		filter: brightness(1.2);
	}
`;
